export default "__VITE_ASSET__tjh_SLtq__"